import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';

import PeriodSummary from "@/components/PeriodSummary";
import PenaltyInfo from '@/components/PenaltyInfo';

const useStyles = makeStyles(() => ({
  none: {
    padding: '20px 0',
  }
}))

function PenaltySummary({ penalties, periods, players, teams }) {
  const classes = useStyles();

  return Object.keys(penalties).map(key => {
    const period = periods[key];
    const periodPenalties = penalties[key];

    return (
      <PeriodSummary key={key} period={period.name}>
        {!periodPenalties.length ?
          <Typography align="center" className={classes.none}>No Penalties</Typography> :
          periodPenalties.map(penalty => (
            <PenaltyInfo
              key={penalty.id}
              penalty={{ ...penalty, period: period.name }}
              players={players}
              teams={teams}
            />
          ))
        }
      </PeriodSummary>
    )
  })
}

export default PenaltySummary;
